export default __webpack_public_path__ + "static/media/Subjugator Dagger.cabfeb02.jpg";